import React from "react";
import { Link } from "@thrivetribe/mvf.ui.organisms.footer";

interface SidebarFaqProps {
  faqHeading: string;
  faqLinks: Link[];
}

export const SidebarFaq: React.FC<SidebarFaqProps> = ({ faqHeading, faqLinks }: SidebarFaqProps) => {
  return (
    <div className="sidebar__bottom-links">
      <div className="sidebar__bottom-links__heading">{faqHeading}</div>
      {faqLinks?.map((link, index) => (
        <a key={index} href={link.url} target={link.target ?? "_self"} className="bottom-link">
          {link.text}
        </a>
      ))}
    </div>
  );
};
